<template>
    <div class="data-trend-wrapper">
        <DataPanel :reqData="reqData" :title="title" serviceName="queryTiketTrend">
            <div slot-scope="slotProps">
                <div class="opt-wrap">
                    <div class="time-wrap">
                        <TimePicker :pickData="pickData" @timeChange="setTimeRanger" :currentPicked="currentPicked"></TimePicker>
                        <el-date-picker
                            v-model="dateValue"
                            type="daterange"
                            value-format="yyyy-MM-dd"
                            :start-placeholder="startTimeLabel"
                            :end-placeholder="endTimeLabel"
                            :picker-options="pickerOptions"
                        >
                        </el-date-picker>
                    </div>
                </div>
                <TrendChart :data="slotProps.data" />
            </div>
        </DataPanel>
    </div>
</template>

<script>
import DataPanel from "@/views/zhiji/components/pagesPanel/DataPanel";
import TimePicker from "@/views/zhiji/bComponents/switchs/TimePicker";
import TrendChart from "./TrendChart";

export default {
    name: "DataTrend",
    props: ["lang", "channel"],
    components: {
        DataPanel,
        TimePicker,
        TrendChart
    },
    data() {
        return {
            currentPicked: 1,
            dateValue: [this.zhiji.getDate(new Date(), 7, "YYYY-MM-DD"), this.zhiji.getDate(new Date(), 1, "YYYY-MM-DD")],
            pickerOptions: {
                disabledDate(time) {
                    const day = 24 * 3600 * 1000;
                    return time.getTime() + 1 * day > Date.now();
                }
            }
        };
    },
    computed: {
        reqData() {
            return {
                channel: this.channel,
                lang: this.lang,
                startTime: this.dateValue[0],
                endTime: this.dateValue[1],
                title: this.$t("zhiji.overview.dataTrend") // 为监听中英文切换
            };
        },
        title() {
            return this.$t("zhiji.overview.dataTrend");
        },
        pickData() {
            return [
                {
                    label: this.$t("zhiji.dataPanel.yesterday"),
                    value: 1
                },
                {
                    label: this.$t("zhiji.dataPanel.sevenDays"),
                    value: 7
                },
                {
                    label: this.$t("zhiji.dataPanel.thirtyDays"),
                    value: 30
                }
            ];
        },
        startTimeLabel() {
            return this.$t("zhiji.serviceData.startTime");
        },
        endTimeLabel() {
            return this.$t("zhiji.serviceData.endTime");
        }
    },
    methods: {
        setTimeRanger(dateStrs) {
            let start = Date.parse(dateStrs[0]) - getDayMilliseconds() * 1;
            let end = Date.parse(dateStrs[1]) - getDayMilliseconds() * 1;
            this.dateValue = [this.zhiji.dateFormat(new Date(start), "YYYY-MM-DD"), this.zhiji.dateFormat(new Date(end), "YYYY-MM-DD")];
        }
    }
};

// 一天的秒数
function getDayMilliseconds() {
    return 24 * 60 * 60 * 1000;
}
</script>

<style lang="scss" scoped>
.data-trend-wrapper {
    margin-bottom: 16px;

    .opt-wrap {
        display: flex;
        justify-content: flex-end;
        position: absolute;
        top: 8px;
        right: 16px;
        .time-wrap {
            display: flex;
        }
    }
    .trend-chart-wrapper {
        margin-bottom: 0;
    }
}
</style>
